export { menuActions } from "./actions";

export { MenuActionTypes } from "./actionTypes";
export { MenuMutationTypes } from "./mutationTypes";
export { MenuGetterTypes } from "./getters";

import { menu } from "./modules";
export default menu;
